"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSchemaAttributes = exports.TrustPilotRatings = void 0;
const TrustPilotRatings = exports.TrustPilotRatings = [0, 0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, '0', '0.5', '1', '1.5', '2', '2.5', '3', '3.5', '4', '4.5', '5'];
const getSchemaAttributes = () => {
  const schemaAttributes = {
    howTo: {
      itemScope: true,
      itemType: 'https://schema.org/HowTo'
    },
    howToStep: {
      itemProp: 'step',
      itemScope: true,
      itemType: 'https://schema.org/HowToStep'
    },
    itemListElement: {
      itemProp: 'itemListElement',
      itemScope: true,
      itemType: 'https://schema.org/HowToDirection'
    },
    product: {
      itemScope: true,
      itemType: 'http://schema.org/Product'
    },
    aggregateRating: {
      itemProp: 'aggregateRating',
      itemScope: true,
      itemType: 'http://schema.org/AggregateRating'
    },
    name: {
      itemProp: 'name'
    },
    description: {
      itemProp: 'description'
    },
    text: {
      itemProp: 'text'
    }
  };
  return schemaAttributes;
};
exports.getSchemaAttributes = getSchemaAttributes;